import { Add } from '@mui/icons-material';
import { Avatar, Box } from '@mui/material';
import React from 'react';
import { COMPCHECK_URL } from 'configs/api';

interface ProfileUploadData {
  image?: File;
  imageURL?: string;
  [key: string]: any;
}

interface ProfileUploadProps {
  data: ProfileUploadData;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function ProfileUpload({ data, onChange }: ProfileUploadProps): React.JSX.Element {
  const resolvedImageUrl = data.imageURL
    ? data.imageURL.startsWith('http')
      ? data.imageURL
      : `${COMPCHECK_URL}/${data.imageURL.replace(/^\/+/, '')}`
    : '';

  const imageSrc = data.image 
    ? URL.createObjectURL(data.image) 
    : data.imageURL 
      ? resolvedImageUrl
      : '';

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', margin: '10px 0px 20px 0px' }}>
      <input
        type="file"
        accept="image/*"
        id="pfp"
        className="hidden"
        onChange={onChange}
      />
      <label
        htmlFor="pfp"
        title="Upload new profile image"
        style={{ position: 'relative' }}
      >
        <Add 
          color="inherit" 
          sx={{
            position: 'absolute',
            bottom: '2px',
            right: '2px',
            zIndex: '99',
            backgroundColor: '#11CDEF',
            borderRadius: '50%',
            color: 'white',
            fontSize: '20px',
            padding: '4px'
          }} 
        />
        <Avatar 
          src={imageSrc} 
          sx={{
            height: '70px',
            width: '70px',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.2)'
            }
          }} 
        />
      </label>
    </Box>
  );
}

